import React from 'react';
import ReactDOM from 'react-dom';
import { Typography } from '@wearesection/raise-ui/atoms';

function ReactRenderParagraphBlock() {
	const raiseParagraphBlocks = Array.from( document.querySelectorAll( '.raise-paragraph:not(.raise-masthead-description)' ) ) as HTMLElement[];
	raiseParagraphBlocks?.length > 0 &&
		raiseParagraphBlocks.forEach( ( element: HTMLElement ) => {
			let className = element?.getAttribute( 'class' ) as string;
			const htmlContent = element?.children?.[ 0 ]?.innerHTML;
			const childrenClass = element?.children?.[ 0 ]?.getAttribute( 'class' ) as string;
			if (childrenClass) {
				className = `${className} ${childrenClass}`
			}
			element.removeAttribute('class')
			ReactDOM.render(
				<Typography className={ className } noVariant>
					<span dangerouslySetInnerHTML={ { __html: htmlContent } } />
				</Typography>,
				element,
			);
		} );
}

export default ReactRenderParagraphBlock;
